// extracted by mini-css-extract-plugin
export default {"row-item":"table-row_row-item__3BUUY"};